// extracted by mini-css-extract-plugin
module.exports = {"ArrowsWrapper":"az_guc","Arrow":"az_huc","Visible":"az_iuc","Prev":"az_juc","Next":"az_kuc","FlippedIcon":"az_luc","PrevIcon":"az_muc"};